import { FC, HTMLAttributes, useRef } from 'react';
import { IListBanner } from 'mod/product-list/interface';
import Image, { ThemeImageProps } from '@base/lib/ThemeImage';
import { isVideoUrl } from 'base/utils/file';
import PureVideo, { IPureVideoRef } from '@base/lib/PureVideo';
import { useHover } from 'ahooks';
import { LazyLoad } from '@base/lib/LazyLoad';
import Link from '@base/lib/ThemeLink';
import { get375CssValue } from 'base/utils/dom-size';
import { isPhone } from 'base/utils/client';

export type IListBannerProps = HTMLAttributes<HTMLDivElement> & {
    banners: IListBanner[];
    width: number;
    height?: ThemeImageProps['height'];
    minHeight?: number;
};

export const ListBanner: FC<IListBannerProps> = props => {
    const containerRef = useRef<HTMLDivElement>(null);
    const linkContainerRef = useRef<HTMLAnchorElement>(null);
    const videoRef = useRef<IPureVideoRef>(null);

    const {
        className,
        banners,
        width,
        height = '100%',
        minHeight,
    } = props;

    useHover(containerRef, {
        onEnter: () => {
            videoRef.current?.play()
        }
    });

    useHover(linkContainerRef, {
        onEnter: () => {
            videoRef.current?.play()
        }
    });

    const banner = banners[0];

    if (!banner) {
        return null;
    }

    const containerStyle = height === '100%' ? {
        minHeight: minHeight
            ? get375CssValue(minHeight)
            : (isPhone ? get375CssValue((width * 320) / 188) : get375CssValue((width * 407) / 278))
    } : {};

    if (isVideoUrl(banner.pic.url)) {
        return banner.url ? (

            <LazyLoad>
                <Link href={banner.url}>
                    <a className={'block w-full h-full'} ref={linkContainerRef} style={containerStyle}>
                        <PureVideo
                            ref={videoRef}
                            src={banner.pic.url}
                            loop
                            autoPlay
                        />
                    </a>
                </Link>
            </LazyLoad>
        ) : (
            <LazyLoad>
                <div className={'w-full h-full'} ref={containerRef} style={containerStyle}>
                    <PureVideo
                        ref={videoRef}
                        src={banner.pic.url}
                        loop
                        autoPlay
                    />
                </div>
            </LazyLoad>
        )
    }

    return isVideoUrl(banner.pic.url) ? (
        <PureVideo
            src={banner.pic.url}
            loop
            autoPlay
        />
    ) : (
        <Image
            className={className}
            src={banner.pic.url}
            alt={banner.pic.altText}
            href={banner.url}
            width={width}
            height={height}
            fit={'cover'}
            style={containerStyle}
        />
    )
};